export default __webpack_public_path__ + "locales/it/UploadPanel.json?hash=c8f5b79dacc6d90267bd1e24a9ecf484";